import { useQuery } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";

export const useCloudsProfiles = (tenants: any, personID: string) => {
  const getProfiles = () => {
    if (!tenants) return;
    return Promise.all(
      tenants?.map((tenant: any) =>
        TenantAPI.getPermissionProfiles(tenant.TenantID)
      )
    ).then((res) => {
      const profiles = tenants.map((t: any) => ({
        TenantID: t.TenantID,
        profile: null,
      }));

      for (let i = 0; i < profiles.length; i++) {
        profiles[i].profile = res[i]?.data?.data?.profiles.filter((p: any) =>
          p.Name.includes("Cloud")
        );
      }
      return profiles;
    });
  };

  const profilesFromTenant = useQuery({
    queryKey: ["profiles", personID, { existingTenants: tenants?.length || 0 }],
    queryFn: () => {
      return getProfiles();
    },
    enabled: tenants && personID ? true : false,
  });

  return {
    profilesFromTenant: profilesFromTenant.data,
    profilesLoading: profilesFromTenant.isLoading,
    profilesError: profilesFromTenant.error,
  };
};
